export default __webpack_public_path__ + "static/colombia-map-4c80ec608d1c88e1273b843df989d7ca.png";